import { render, staticRenderFns } from "./ButtonMod.vue?vue&type=template&id=51bc9e7c"
import script from "./ButtonMod.vue?vue&type=script&lang=js"
export * from "./ButtonMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports